export default __webpack_public_path__ + "static/media/image.medisend.543ed09e.png";